import { Component, Inject, OnInit, Optional, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TicketPerfil } from 'src/app/shared/model/tickets/ticketperfil.model';

import swal from 'sweetalert2';
import { Tickets } from 'src/app/shared/model/tickets/tickets.model';
import { TicketAprobadoPerfil, TicketEsquemaPerfil, TicketNivelPerfil, TicketProyectoPerfil } from 'src/app/utilerias/enums/ticket-perfil.enum';
import { Prioridad } from 'src/app/shared/model/tickets/prioridad.model';
import { Cliente } from 'src/app/shared/model/ajustesUsuario/cliente.model';
import { DatePipe, Location, NgIf, NgFor, AsyncPipe } from '@angular/common';
import { ReplaySubject } from 'rxjs';
import { AddclientemodalComponent } from 'src/app/clientes/addclientemodal/addclientemodal.component';
import { GestionUsuariosService } from 'src/app/usuarios/gestionusuarios.service';
import { TicketsService } from 'src/app/tickets/tickets.service';
import { Router } from '@angular/router';
import { MatFormField, MatInput, MatError, MatLabel, MatSuffix } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { regresaDeSolicitud } from '../../regreso-solicitud';

@Component({
    selector: 'app-solicitud-perfil-tickets',
    standalone: true,
    templateUrl: './solicitudPerfilTickets.component.html',
    styleUrls: ['./solicitudPerfilTickets.component.css'],
    imports: [FormsModule, ReactiveFormsModule, MatFormField, MatInput, NgIf, MatError, MatLabel, MatSelect, NgFor, MatOption, NgxMatSelectSearchModule, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker, AsyncPipe, DatePipe]
})
export class SolicitudPerfilTicketsComponent implements OnInit {
  options: FormGroup;
  perfil: TicketPerfil;
  nivelesEnum = Object.values(TicketNivelPerfil);
  aprobadoPorEnum = Object.values(TicketAprobadoPerfil);
  esquemaEnum = Object.values(TicketEsquemaPerfil);
  tipoProyectoEnum = Object.values(TicketProyectoPerfil);
  prioridadesFiltradas: Prioridad[];
  clientes: Cliente[];
  esEdicion: boolean;
  formCliente = new FormControl();
  public filterCliente: ReplaySubject<Cliente[]> = new ReplaySubject<Cliente[]>(1);
  datosUsuario: Tickets;
  estado: String = '';


  constructor(private fb: FormBuilder,
    // public modal: MatDialogRef<SolicitudPerfilTicketsComponent>,
    private ticketsService: TicketsService,
    // @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private cliente: GestionUsuariosService,
    private router: Router,
    private datePipe: DatePipe,
    private location: Location,
    // Abierta como ventana («Editar» del detalle del perfil).
    @Optional() private ventana: MatDialogRef<SolicitudPerfilTicketsComponent>) {

  }

  ngOnInit() {
    this.perfil = new TicketPerfil();
    this.perfil.ticket = new Tickets();
    this.datosUsuario = new Tickets();
    // this.formCliente.valueChanges.subscribe(() => {
    //   this.filtracliente();
    // });
    var datosPerfil = JSON.parse(localStorage.getItem('datoPerfil'));
    var datoClientes = JSON.parse(localStorage.getItem('datoClientes'));
    var Prioridades = JSON.parse(localStorage.getItem('Prioridades'));
    this.perfil.ticket.areaResolutora = datosPerfil.areaResolutora;
    this.perfil.ticket.areaSolicitante = datosPerfil.areaSolicitante;
    this.perfil.ticket.nombreSolicitante = datosPerfil.nombreSolicitante;
    this.perfil.ticket.fechaSolicitud = datosPerfil.fechaSolicitud;      
    this.clientes = datoClientes;
    this.prioridadesFiltradas = Prioridades;
    this.estado = "CREADO"

    // this.esEdicion = this.data.edicion;
    // if (!this.esEdicion) {
    //   this.perfil.ticket = this.data.perfil;
    //   this.clientes = this.data.clientes;
    //   this.datosUsuario.nombreSolicitante = this.perfil.ticket.nombreSolicitante;
    //   this.datosUsuario.areaSolicitante = this.perfil.ticket.areaSolicitante;
    //   this.datosUsuario.areaResolutora = this.perfil.ticket.areaResolutora;
    //   this.filtracliente();
    //   this.prioridadesFiltradas = this.data.prioridades;
    // } else {
    // }

    this.initializeForm();
  }

  initializeForm() {
    this.options = this.fb.group({
      perfilCtrl: [{ value: '', disabled: this.esEdicion }, Validators.required],
      numPerfilesCtrl: [{ value: '', disabled: this.esEdicion }, Validators.required],
      nivelPerfilCtrl: [{ value: '', disabled: this.esEdicion }, Validators.required],
      experienciaCtrl: [{ value: '', disabled: this.esEdicion }, Validators.required],
      conocimientoDeseableCtrl: [{ value: '', disabled: this.esEdicion }, Validators.required],
      consideracionesCtrl: [{ value: '', disabled: this.esEdicion }, Validators.required],
      tipoProyectoCtrl: ['', Validators.required],
      fechaInicioCtrl: ['', Validators.required],
      fechaFinCtrl: ['', Validators.required],
      ubicacionClienteCtrl: [''],
      sueldoOfertaCtrl: [''],
      horarioCtrl: [''],
      tarifaCtrl: [''],
      tipoContratacionCtrl: [''],
      esquemaSueldoCtrl: [''],
      equipoRequeridoCtrl: [''],
      equipoRequerido: [''],
      fechaSolicitudCtrl: [''],
      nombreSolicitanteCtrl: [''],
      aprobadoPorCtrl: [''],
      prioridadCtrl: [''],
      idClienteCtrl: [''],
      areaSoliCtrl: [''],
      areaResoluCtrl: [''],
      recursoDisponibleCtrl: [''],
      estatusCtrl: [''],
      lugartrabajoCtrl: [''],
      inglesCtrl: ['']
    });
    this.filtracliente();
  }
  guardaPerfilTicket() {
    this.ticketsService.guardarPerfilTicket(this.perfil).subscribe(res => {
      if (res != null) {
        swal.fire({
          title: '¡Se ha generado la solicitud de Perfil! Con el folio: ' + res.ticket.id_ticket,
          timer: 5000,
          icon: 'success',
          showConfirmButton: true
        }).then(responeMsg => {
          if (res.pCodRetorno === '00000') {
            this.router.navigate(["TICKETS/Cte"]);
            // this.modal.close();
          } else {
            /* this.inputAsuntoCtrl.nativeElement.focus(); */
          }
        });
      } else {
        swal.fire({
          title: ' Fallo la generación del Ticket.',
          timer: 5000,
          icon: 'error',
          showConfirmButton: true
        });
      }
    });
  }

  getCliente(): void {
    this.cliente.getClientes().subscribe(response => {
      if (response.pCodRetorno === '00000') {
        this.clientes = response.list;
      }
    });
  }

  filtracliente() {
    if (!this.clientes) { return; }
    let search = this.formCliente.value;
    if (!search) {
      this.filterCliente.next(this.clientes.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filterCliente.next(
      this.clientes.filter(cliente => cliente.razonsocial.toLowerCase().indexOf(search) > -1)
    );
  }

  agregarcliente(): void {
    let dialogRef = this.dialog.open(AddclientemodalComponent, {
      disableClose: true,
      autoFocus: true,
      width: "60%",
      panelClass: "custom-modalbox",
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getCliente();
    });
  }

  salir() {
    if (this.ventana) {
      this.ventana.close();
      return;
    }
    regresaDeSolicitud(this.location, this.router);
  }

  limpiar(): void {
    this.options.reset();
    this.options.patchValue({
      nombreSolicitanteCtrl: this.datosUsuario.nombreSolicitante,
      fechaSolicitudCtrl: this.datePipe.transform(new Date(), 'dd-MMMM-yyyy'),
      areaSoliCtrl: this.datosUsuario.areaSolicitante,
      areaResoluCtrl: this.datosUsuario.areaResolutora,
    });
  }

}
